import { useEffect, useState } from 'react';
import { useRxCollection } from 'rxdb-hooks';

import { sentryCaptureException } from '../../utilities/sentryCaptureException';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type {
  SignAndStampUserConsentFileCollection,
  SignAndStampUserConsentFileDocument,
} from './signAndStampUserConsent.types';

export const useSignAndStampUserConsent = () => {
  const signAndStampUserConsentFileCollection: SignAndStampUserConsentFileCollection =
    useRxCollection(RxdbCollectionName.SIGN_AND_STAMP_USER_CONSENT);

  const [signAndStampUserConsentInitialized, setSignAndStampUserConsentInitialized] =
    useState<boolean>(false);

  useEffect(() => {
    if (signAndStampUserConsentFileCollection) {
      setSignAndStampUserConsentInitialized(true);
    }
  }, [signAndStampUserConsentFileCollection]);

  const getSignAndStampUserConsent = async (): Promise<SignAndStampUserConsentFileDocument[]> => {
    if (!signAndStampUserConsentFileCollection) return [];
    let signAndStampUserConsent: SignAndStampUserConsentFileDocument[];
    try {
      signAndStampUserConsent = await signAndStampUserConsentFileCollection
        ?.find({
          selector: {
            isActive: { $eq: true },
          },
        })
        .exec();
      return signAndStampUserConsent;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(
        '🚀 ~ file: useSignAndStampUserConsent.ts ~ line 30 ~ getSignAndStampUserConsent ~ error',
        error,
      );
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(
        error,
        '~ file: useSignAndStampUserConsent.tsx ~ line 30 ~ getSignAndStampUserConsent ~',
      );
      throw new Error(`error ${error}`);
    }
  };

  return {
    signAndStampUserConsentInitialized,
    signAndStampUserConsentFileCollection,
    getSignAndStampUserConsent,
  };
};
export default useSignAndStampUserConsent;
